import './style.scss';
import Link from './link.js';

export default Link;